import { MultiTextBoxItemType, SurveyElement } from 'utils/surveyBuilder/enums';

const onAddTranslation = (languageToAdd, setSurvey) => {
  setSurvey((prevState) => {
    const {
      pagesOrder,
      pages,
      sections,
      items,
      availableLanguages,
      versionTitle,
    } = prevState;

    pagesOrder.forEach((pageId) => {
      const { title: pageTitle, sectionIds } = pages[pageId];

      pageTitle[languageToAdd] = '';

      sectionIds.forEach((sectionId) => {
        const { title: sectionTitle, itemIds } = sections[sectionId];

        sectionTitle[languageToAdd] = '';

        itemIds.forEach((itemId) => {
          const {
            type: itemType,
            content: itemContent,
            question,
            questionGroup,
          } = items[itemId];

          if (itemType === SurveyElement.TEXT_BOX) {
            itemContent[languageToAdd] = '';
          }

          if (itemType === SurveyElement.QUESTION) {
            const { content, choices, dataSet } = question;

            content[languageToAdd] = '';

            const choicesAreFromDataSet = !!dataSet.id;

            if (!choicesAreFromDataSet) {
              choices.forEach((_, index) => {
                choices[index].option[languageToAdd] = '';
              });
            }
          }

          if (itemType === SurveyElement.QUESTION_GROUP) {
            const { questions } = questionGroup;

            questions.forEach(({ content }) => {
              // eslint-disable-next-line no-param-reassign
              content[languageToAdd] = '';
            });
          }

          if (itemType === SurveyElement.MULTI_TEXT_BOX) {
            const currentMultiTextBoxItem = items[itemId];

            const newInnerItems = (currentMultiTextBoxItem.items || []).map(
              (innerItem) => {
                if (innerItem.type === MultiTextBoxItemType.TEXT_BOX) {
                  const updatedInnerTextBox = { ...innerItem };

                  return {
                    ...updatedInnerTextBox,
                    richText: {
                      ...updatedInnerTextBox.richText,
                      [languageToAdd]: '',
                    },
                    content: {
                      ...updatedInnerTextBox.content,
                      [languageToAdd]: '',
                    },
                  };
                }

                if (innerItem.type === MultiTextBoxItemType.ACCORDION) {
                  const updatedAccordion = { ...innerItem };
                  updatedAccordion.items = (updatedAccordion.items || []).map(
                    (panel) => {
                      const updatedPanel = { ...panel };

                      // Panel title
                      const newTitleContent = {
                        ...(updatedPanel.title.content || {}),
                        [languageToAdd]: '',
                      };

                      // Panel body
                      const newBody = {
                        ...(updatedPanel.body || {}),
                        content: {
                          ...(updatedPanel.body.content || {}),
                          [languageToAdd]: '',
                        },
                        richText: {
                          ...(updatedPanel.body.richText || {}),
                          [languageToAdd]: '',
                        },
                      };

                      return {
                        ...updatedPanel,
                        title: {
                          ...updatedPanel.title,
                          content: newTitleContent,
                        },
                        body: {
                          ...updatedPanel.body,
                          ...newBody,
                        },
                      };
                    }
                  );
                  return updatedAccordion;
                }

                return innerItem;
              }
            );

            items[itemId] = {
              ...currentMultiTextBoxItem,
              items: newInnerItems,
            };
          }
        });
      });
    });

    availableLanguages.push(languageToAdd);

    return {
      ...prevState,
      versionTitle: { ...versionTitle, [languageToAdd]: '' },
    };
  });
};

export { onAddTranslation };
